import React from "react";
import { Spinner } from "common/ui/Spinner";
import { Loading } from "common/ui/Loading";

import styles from "./PageLoading.module.scss";

export function PageLoading(props: {
  progress?: boolean,
  loading?: { title: string, body: string }
}) {
  return (
    <div className={styles.PageLoading}>
      {props.progress ? (
        <Loading title={props.loading?.title} body={props.loading?.body} />
      ) : (
        <Spinner />
      )}
    </div>
  );
}

